import style from "./style";

const BudgetExpenseLegend = (props) => (
  <div
    class={
      props.isLeftAligned ? style.legend_container_left : style.legend_container
    }
  >
    <span class={style.legend_item}>
      <span class={style.budget_legend_block} />
      <span class={style.legend_text}>{props.yearly ? "Current year budget release" : "Budget" }</span>
    </span>
    <span class={style.legend_item}>
      <span class={style.expense_legend_block} />
      <span class={style.legend_text}>{props.yearly ? "Life to date expense" : "Expense" }</span>
    </span>
  </div>
);

export default BudgetExpenseLegend;



// WEBPACK FOOTER //
// ./components/budget-expense-legend/index.js